import { render, staticRenderFns } from "./NoticeDrewer.vue?vue&type=template&id=0503ddf8&scoped=true"
import script from "./NoticeDrewer.vue?vue&type=script&lang=js"
export * from "./NoticeDrewer.vue?vue&type=script&lang=js"
import style0 from "./NoticeDrewer.vue?vue&type=style&index=0&id=0503ddf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0503ddf8",
  null
  
)

export default component.exports